<template>
  <div
    class="flex flex-col w-full mx-auto overflow-hidden bg-white border border-solid rounded-lg shadow-lg select-none border-neutral-300"
  >
    <div
      @click="toggleMinimize"
      class="sticky top-0 z-10 flex items-center justify-between p-4 bg-white border-b border-solid rounded-t-lg border-neutral-300"
      :class="{ 'cursor-pointer hover:bg-neutral-100': state.showMinimize }"
    >
      <!-- Panel title -->
      <h3 class="text-lg font-semibold truncate text-neutral-800">
        {{ title }}
      </h3>
      <!-- Minimize/Maximize icons -->
      <div v-if="state.showMinimize" class="text-neutral-800">
        <ChevronDown v-if="isMinimized" :size="20" />
        <ChevronUp v-else :size="20" />
      </div>
      <button v-else-if="showMaximize" class="text-neutral-800 bg-neutral-100 hover:bg-neutral-200 p-3 -my-2.5 -mx-1.5 rounded-lg flex items-center justify-center border-none" @click="emit('maximize')">
        <Maximize2 :size="16" />
      </button>
    </div>
    <!-- Panel content -->
    <div
      v-show="!isMinimized || !state.showMinimize"
      :class="[
        'flex-grow overflow-y-auto transition-all duration-300 ease-in-out',
        { 'p-4': !noPadding }
      ]"
    >
      <div class="space-y-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, reactive, defineProps, defineEmits } from "vue";
import { ChevronDown, ChevronUp, Maximize2 } from "lucide-vue-next";

// Define props
defineProps({
  title: {
    type: String,
    default: "",
  },
  showMaximize: {
    type: Boolean,
    default: false,
  },
  noPadding: {
    type: Boolean,
    default: false,
  },
});

// Define emits
const emit = defineEmits(["maximize"]);

// Reactive state
const isMinimized = ref(false);
const state = reactive({
  showMinimize: false,
});

// Method to toggle minimize state
const toggleMinimize = () => {
  if (state.showMinimize) {
    isMinimized.value = !isMinimized.value;
  }
};

// Method to check screen size and update state
const checkScreenSize = () => {
  state.showMinimize = window.innerWidth < 1024;
};

// Lifecycle hooks
onMounted(() => {
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkScreenSize);
});
</script>